/* The Property Manager guide, as the sidebar links to it.

   The file is `web/public/guide-for-property-managers.docx`. Nothing puts it
   there by hand: `npm run build:guide` in `docs/user-guides` writes it in the
   same run, from the same bytes, as the copy in `docs/` that people are sent
   by email -- so the guide somebody downloads from inside the Hub cannot be
   an older document than the one they were given. `guide-copy.test.js` fails
   if those two copies ever stop matching.

   `FILENAME` is what the browser saves the file as, and it is deliberately
   not the terse name in the URL: somebody who downloads this wants to find it
   again next to the copy that was emailed to them. */
export const GUIDE_URL = '/guide-for-property-managers.docx';
export const GUIDE_FILENAME = 'Westwood Project Hub - Guide for Property Managers.docx';
export const GUIDE_LABEL = 'Property Manager Guide';
